import { Grid } from '@material-ui/core';
import { OverflowTooltip } from '@backstage/core-components';

export const ScoreRuleLabels = ({ scoreRules }: any) => {
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      {[scoreRules.red, scoreRules.orange, scoreRules.green].map(
        (rule, idx) => (
          <Grid key={idx} item xs={12} md={4}>
            <rule.icon />
            <OverflowTooltip title={rule.text} text={rule.info} line={2} />
          </Grid>
        ),
      )}
    </Grid>
  );
};
